import { useWindowSize } from 'CustomHooks/useWindowSize';
import { useEffect, useState } from 'react';

function useGetCanvasSizeByParentContainer(parentRef: any) {
  const [canvasSize, setCanvasSize] = useState({
    width: 250,
    height: 174.5,
  });
  const size = useWindowSize();

  useEffect(() => {
    const canvas = parentRef?.current;
    if (canvas) {
      setCanvasSize({
        width: canvas?.clientWidth,
        height: canvas?.clientHeight,
      });
    }
  }, [parentRef, size]);
  return canvasSize;
}

export { useGetCanvasSizeByParentContainer };
